import type { Mutation, MutationUploadImagesArgs } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { UPLOAD_IMAGES } from './gql/uploadImages';

type MutationDataType = Pick<Mutation, 'uploadImages'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('uploadImages');

export const useUploadImages = () => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [uploadImages, { loading, error, data }] = useMutation<MutationDataType, MutationUploadImagesArgs>(
        UPLOAD_IMAGES,
        {
            onError
        }
    );

    const outgoingUploadImages = useCallback(
        (imageData: MutationUploadImagesArgs['imageData']) => {
            uploadImages({ variables: { imageData } });
        },
        [uploadImages]
    );

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        success: !!data,
        error: !!error,
        uploadImages: outgoingUploadImages,
        loading,
        response
    };
};
